import { computed, readonly } from 'vue';
import { useStorage } from '@vueuse/core';
import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'qbeek:onboarding-session';

function initialSession() {
  return {
    applicationId: '',
    userId: '',
    token: '',
    region: '',
    completionKey: '',
  };
}

const session = useStorage(STORAGE_KEY, initialSession(), sessionStorage, {
  mergeDefaults: true,
});

export function useOnboardingSession() {
  const hasSession = computed(() => Boolean(session.value.token && session.value.applicationId));

  function acceptRegistration(data, region) {
    session.value = {
      applicationId: data.applicationId,
      userId: data.userId,
      token: data.onboardingToken,
      region,
      completionKey: '',
    };
  }

  function getCompletionKey() {
    if (!session.value.completionKey) {
      session.value.completionKey = uuidv4();
    }
    return session.value.completionKey;
  }

  function clearSession() {
    session.value = initialSession();
  }

  return {
    session: readonly(session),
    hasSession,
    acceptRegistration,
    getCompletionKey,
    clearSession,
  };
}
